<template>
  <div class="scroll-container">
    <div class="scroll-content">
      <div class="scroll-item" v-for="(item, index) in list" :key="index">{{ item }}</div>
      <div class="scroll-item" v-for="(item, index) in list" :key="`a${index}`">{{ item }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MarqueeRoll",
    props: {
 
    list: Array,
  
  },
  data() {
    return {
     
    }
  }
}
</script>

<style scoped>
.scroll-container {
  width: 100%;
  height: 22px;
  overflow: hidden;
  position: relative;
}

.scroll-content {
  display: inline-block;
  white-space: nowrap;
  animation: scroll 15s linear infinite;
}

.scroll-item {
  width: 167px;
  height: 22px;
  line-height: 22px;
  font-size: 11px;
  color: #fff;
 
  border-radius: 11px;
 
  display: inline-block;
  text-align: center;
  margin-right: 10px;

/* 关键：用 rgba 背景实现透明，不要用 opacity */
background: rgba(11, 11, 11, 0.25);
border-radius: 25px;

}

@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
</style>